import OptionMenu, { OptionMenuProps } from './OptionMenu';

export type { OptionMenuProps };
export default OptionMenu;
